<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>订单管理</el-breadcrumb-item>
			<el-breadcrumb-item>订单列表</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="订单号|手机号|收件人" v-model="searchForm.keyword" style="margin-right: 10px; width:200px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
				<el-button size="mini" type="success" @click="exports()">导出选中订单</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border @selection-change="handleSelectionChange" 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
				
				<el-table-column
				      type="selection" align="center"
				      width="55">
				    </el-table-column>
			    <el-table-column prop="order_sn" label="订单号" align="center"  width="200"></el-table-column>
				
				<el-table-column prop="uid" label="下单用户手机" align="center"  width="120">
					<template slot-scope="scope">
						{{scope.row.buy_phone}}
					</template>
				</el-table-column>
				<el-table-column prop="goods_name" label="商品名称" align="center"  width="250">
				</el-table-column>
				<el-table-column prop="amount" label="订单金额" align="center" width="100">
				</el-table-column>
				
				<el-table-column prop="times" label="发货次数" align="center" width="100">
				</el-table-column>
				
				<el-table-column prop="sended_times" label="已发货次数" align="center" width="100">
				</el-table-column>
				
				<el-table-column prop="realname" label="收件人信息" align="center"  width="250">
					<template slot-scope="scope">
						{{scope.row.realname}},{{scope.row.phone}},{{scope.row.address}}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" align="center" width="170">
					<template slot-scope="scope">
						<el-button type="primary" @click="changeStatus(scope, 0)" v-if="scope.row.status==3" size="mini">已收货</el-button>
						<el-button type="primary" @click="changeStatus(scope, 0)" v-if="scope.row.status==2" size="mini">已发货，待收货</el-button>
						<el-button type="primary" @click="changeStatus(scope, 0)" v-if="scope.row.status==1" size="mini">已付款，待发货</el-button>
						<el-button type="warning" @click="changeStatus(scope, 1)" v-if="scope.row.status==0" size="mini">待付款</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="下单时间" align="center" width="170">
				</el-table-column>
				
				<el-table-column prop="pay_time" label="付款时间" align="center" width="170">
				</el-table-column>
				
				<el-table-column prop="wx_order" label="微信订单号" align="center" width="300">
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" align="center" width="300">
					<template slot-scope="scope">
						<el-button type="danger" @click="sendOrder(scope)" v-if="scope.row.status != 0" size="mini">发货</el-button>
<!-- 						<el-button type="primary" @click="editFunc(scope)" v-if="scope.row.status != 0" size="mini">查看订单</el-button> -->
						<el-button type="warning" @click="deleteFunc(scope)" size="mini">删除</el-button>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		
	</div> 
</template>

<script>
	import * as XLSX from "xlsx"
	import { saveAs } from "file-saver"
	
	export default {
		components:{
		},
		computed:{
		},
		data(){
			return {
				searchForm:{
					keyword:'',
					is_agent:'',
					online:'',
					endTime:'',
					pid:'',
				},
				dialogVisible1:false,
				dialogVisible:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				editInfo:{},
				multipleSelection:[],
			}
		},
		created() {
			this.getData();
		},
		methods:{
			exports() {
			      if (this.multipleSelection.length === 0) {
			        this.$message.warning("请先选择要导出的行")
			        return
			      }
			
			      // 1. 将选中数据转为 sheet
			      const ws = XLSX.utils.json_to_sheet(this.multipleSelection)
			
			      // 2. 创建 workbook
			      const wb = XLSX.utils.book_new()
			      XLSX.utils.book_append_sheet(wb, ws, "订单数据")
			
			      // 3. 生成并下载文件
			      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" })
			      saveAs(new Blob([wbout], { type: "application/octet-stream" }), "订单数据.xlsx")
			    },
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			sendOrder(scope){
				console.log('sendOrder', scope);
			},
			reset(){
				this.searchForm = {
					keyword:''
				};
			},
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Order/deleteOrder", {orid:scope.row.orid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('是否确认删除此订单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.deleteApi(scope);
				}).catch(() => {      
				});
			},
			editFunc(scope){
				this.editInfo = scope.row;
				this.dialogVisible1 = true;
			},
			addFunc(){
				this.dialogVisible = true;
			},
			handleClose(){
				this.dialogVisible = false;
				this.dialogVisible1 = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Order/getOrderList", {page:this.currentPage, limit:this.limit, ...this.searchForm}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

